import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface AccountTypeState {
  accountType: "personal" | "business" | null
}

const initialState: AccountTypeState = {
  accountType: null,
}

const accountTypeSlice = createSlice({
  name: "accountType",
  initialState,
  reducers: {
    setAccountType: (state, action: PayloadAction<"personal" | "business">) => {
      state.accountType = action.payload
    },
    clearAccountType: (state) => {
      state.accountType = null
    },
  },
})

export const { setAccountType, clearAccountType } = accountTypeSlice.actions
export default accountTypeSlice.reducer
